import { render } from "./EditLocation.vue?vue&type=template&id=378538ae&scoped=true"
import script from "./EditLocation.vue?vue&type=script&lang=js"
export * from "./EditLocation.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-378538ae"

export default script